import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const monthlyOfferClickHit = (url: string) => {
    const adDomain = new URL(url).searchParams.get("pgDomain");
    const adHostname = adDomain !== null ? new URL(adDomain).hostname : "";
    const payload = {
        view_type: "offer_list",
        ...getTrackedSiteData()
    };
    const isInternalURL = adHostname.includes("rynekpierwotny");
    //At this moment monthly offer contain only internal redirect
    //To prevent double month_offer_internal events if this will ever change without our knowledge
    if (!isInternalURL) {
        return;
    }

    hitAlgolytics("month_offer_internal", payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const monthlyOfferClickHit = (url: string) => {
    const adDomain = new URL(url).searchParams.get("pgDomain");
    const adHostname = adDomain !== null ? new URL(adDomain).hostname : "";
    const payload = {
        view_type: "offer_list",
        ...getTrackedSiteData()
    };
    const isInternalURL = adHostname.includes("rynekpierwotny");
    //At this moment monthly offer contain only internal redirect
    //To prevent double month_offer_internal events if this will ever change without our knowledge
    if (!isInternalURL) {
        return;
    }

    hitAlgolytics("month_offer_internal", payload);
};
